import React, { Component } from 'react';
import {
    Container,
} from 'reactstrap';
import FormsContainer from '../components/Forms/FormsContainer';

class Forms extends Component {

    componentDidMount = () => {
        this.props.log('Forms.js/componentDidMount');
    }

    render() {
        return (<Container fluid={true}>
            <FormsContainer {...this.props} />
        </Container>
        );
    }
}

export default Forms;
